import { render, staticRenderFns } from "./ScoreLoading.vue?vue&type=template&id=6ccaa718&"
import script from "./ScoreLoading.vue?vue&type=script&lang=js&"
export * from "./ScoreLoading.vue?vue&type=script&lang=js&"
import style0 from "./ScoreLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports